import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { emtSocket } from "../../../CommonFunction/SocketClient";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import OngoingBox from "./Booking/Ongoing/Ongoing components/OngoingBox/OngoingBox";
import "./BookingPage.scss";
import { BookingPageFields } from "./BookingPageConfig";
import BookingPageInputs from "./BookingPageInputs";

const AllData = gql`
  query TripBookingsByID($TripBookingsByIdId: ID) {
    TripBookingsByID(id: $TripBookingsByIdId) {
      _id
      Sp_Account_Name
      SP_Mobile_Number
      LP_Business_Name
      LP_Mobile_Number
      Loading_City
      Unloading_City
      BidId {
        _id
        LoadId
        UserId
        Price
        Unique_Id
        No_Of_Vehicle
        Confirm_Qty
        Trip_Bookings
        Bid_Note
        Bid_History
        createdAt
        updatedAt
      }
      
      UserId
    
      LoadId {
        _id
        Unique_Id
        UserId
        Load_Post_Type
        Auction_Date
        Auction_Time
        Dangerous_Goods
        Exact_Content
        Expected_Price
        Target_Price
        From_City
        Load_Live_Duration
        Load_Manager {
          _id
        }
        Loading_Area
        Loading_By
        Loading_City
        Loading_Date
        Loading_Landmark
        Loading_Name
        Loading_Pincode
        Loading_Scope
        Loading_State
        Loading_Time
        Loading_Address_Line_1
        Loading_Address_Line_2
        Material_Category
        Material_Dimension
        Material_Dimension_In
        Material_Insurence
        Material_Image
        Material_Image_2
        Material_Image_3
        No_Of_Vehicels_Required
        No_Of_Vehicels_Loading_Completed
        Notes
        Over_Dimension_Cargo
        Payment_Type {
          Name
          _id
        }
        Rate_per
        To_City
        Total_Weight
        Unloading_Area
        Unloading_City
        Unloading_Landmark
        Unloading_Name
        Unloading_Pincode
        Unloading_Scope
        Unloading_State
        Unloading_Address_Line_1
        Unloading_Address_Line_2
        Vehicle_Type_String
        Vehicle_Category_String
        Vehicle_Type {
          _id
          Unique_Id
          Vehicle_Type
          User_ID
          Search_Value
          createdAt
          updatedAt
        }
        Vehicle_Category {
          _id
          Unique_Id
          Name
          Search_Value

          User_ID
          createdAt
          updatedAt
        }
        Length_Category {
          _id
          length
          Search_Value
          createdAt
          updatedAt
        }
        Is_Live
        Is_Auction_Started
        Is_Archive
        BidDetails {
          _id
          LoadId
          UserId
          Price
          Unique_Id
          No_Of_Vehicle
          Confirm_Qty
          Trip_Bookings
          Bid_Note
          Bid_History
          createdAt
          updatedAt
        }
        VehicleCategoryGroupData {
          VehicleType
          VehicleCategory {
            _id
            Unique_Id
            Name
            User_ID
            createdAt
            updatedAt
          }
        }
        Total_Weight_In
        createdAt
        updatedAt
      }
      Unique_Id
      Vehicle_Number {
        _id
        Unique_Id
        UserId
        Vehicle_No
        createdAt
        updatedAt
      }
      Vehicle_Capacity
      DL_Photo
      Driver_Name
      Freight_Amount
      Platform_Charges
      Current_Stage
      Driver_Number
      Reporting_Time
      Is_Confirmed
      Is_Accepted
      Is_Rejected
      GPS_Link
      Sim_Tracking_Link
      LR_No
      TripBooking_Confirmed
      TripBooking_Confirmed_Time
      Vehicle_Reached_At_Loading_Point
      Vehicle_Reached_At_Loading_Point_Time
      Loading_Completed
      Loading_Completed_Time
      Advance_Processed
      Advance_Processed_Time
      Vehicle_Reach_At_Unloading_Point
      Vehicle_Reach_At_Unloading_Point_Time
      Unloading_Completed
      Unloading_Completed_Time
      Clear_Delivery_Confirmation
      Clear_Delivery_Confirmation_Time
      POD_Collected_From_SP
      POD_Submitted_To_LP
      POD_Collected_From_SP_Time
      POD_Submitted_To_LP_Time
      Invoice_Number
      Eway_Bill_Number
      Eway_Bill_Created_Date
      Eway_Bill_Validate_Date
      Vehicle_Front_Img
      Vehicle_Back_Img
      Vehicle_Right_Img
      Vehicle_Left_Img
      Material_Img
      Entry_Gate_Img
      POD_Front_Copy
      POD_Back_Copy
      Invoice_Copy
      Final_Invoice_Copy
      Holding_Charges
      Hamali_Charges
      Extra_Running
      Challan_Demand
      Other_Charges
      Other_Charges_Reason
      Narration
      Sp_Claim_Raised
      Lp_Claim_Raised
      Sp_Claim_Cleared
      Lp_Claim_Cleared
      Expired
      Time_Out_Expired
      createdAt
      updatedAt
    }
  }
`;


export const EDIT_Trip_BookingS_DATA = gql`
  mutation EditTripBookings($editTripBookingsId: ID!, $userInput: TripBookingsInput!) {
    editTripBookings(id: $editTripBookingsId, userInput: $userInput) {
      id
      BidId
      UserId
      LoadId
      Unique_Id
      Vehicle_Number {
        _id
        Unique_Id
        UserId
        Vehicle_No
        createdAt
        updatedAt
      }
      Vehicle_Capacity
      Driver_Name
      POD_Collected_From_SP
      POD_Submitted_To_LP
      Freight_Amount
      Platform_Charges
      Current_Stage
      Driver_Number
      Reporting_Time
      Is_Confirmed
      Is_Accepted
      Is_Rejected
      Booking_Confirmed
      TripBooking_Confirmed_Time
      Vehicle_Reached_At_Loading_Point
      Vehicle_Reached_At_Loading_Point_Time
      Loading_Completed
      Loading_Completed_Time
      Advance_Processed
      Advance_Processed_Time
      Vehicle_Reach_At_Unloading_Point
      Vehicle_Reach_At_Unloading_Point_Time
      Unloading_Completed
      Unloading_Completed_Time
      Clear_Delivery_Confirmation
      Clear_Delivery_Confirmation_Time
      POD_Collected_From_SP_Time
      POD_Submitted_To_LP_Time
      Invoice_Number
      Eway_Bill_Number
      Eway_Bill_Created_Date
      Eway_Bill_Validate_Date
      Vehicle_Front_Img
      Vehicle_Back_Img
      Vehicle_Right_Img
      Vehicle_Left_Img
      Material_Img
      Entry_Gate_Img
      POD_Front_Copy
      POD_Back_Copy
      Invoice_Copy
      Final_Invoice_Copy
      Holding_Charges
      Hamali_Charges
      Extra_Running
      Challan_Demand
      Other_Charges
      Other_Charges_Reason
      Narration
      Sp_Claim_Raised
      Lp_Claim_Raised
      Sp_Claim_Cleared
      Lp_Claim_Cleared
      createdAt
      updatedAt
    }
  }
`;

const EditBookingPageModal = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
}) => {
  const Tab = useSelector((store: any) => store.SelectedTabData.tab);
  const [openModal, setOpenModal] = useState(show ? show : false);
  const [BookingData, setBookingData] = useState({});
  const [editTemplate] = useMutation(EDIT_Trip_BookingS_DATA);
  let Refetch = useSelector((store: any) => store.FormFieldData.refresh);
  const dispatch = useDispatch();
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux[Tab]?.Selected_Row;
  const FormData = useSelector((store: any) => store.FormFieldData);
  const [getBookingData, { refetch }] = useLazyQuery(AllData, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  useEffect(() => {
    if (TypeOfPortal === "Edit") {
      getBookingData({
        variables: {
          TripBookingsByIdId: fielddata?._id,
        },
      }).then(({ data }) => {
        
        setBookingData(data?.TripBookingsByID[0]);
      });
    }
  }, [fielddata]);

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    setOpenModal(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  useEffect(() => {
    // emtSocket.on("CurrentTask_Update", (id) => {
    //   refetch({
    //     variables: {
    //       id: fielddata?._id,
    //     },
    //   });
    // });
  });

  useEffect(() => {
    if (Refetch) {
      refetch({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        setBookingData(data?.TripBookingsByID[0]);
        dispatch({ type: "Refetch", payload: false });
      });
    }
  }, [Refetch]);

  useEffect(() => {
    if (show === true) {
      setOpenModal(true);
    }
  }, [show]);

  const submit = async () => {
    let data: any = {};

    data.GPS_Link = FormData?.fielddata?.Booking_Page_Input?.GPS_Link;
    data.Sim_Tracking_Link =
      FormData?.fielddata?.Booking_Page_Input?.Sim_Tracking_Link;
    if (data.GPS_Link || data.Sim_Tracking_Link) {
      await editTemplate({
        variables: {
          id: FormData.selectedRow[0]._id,
          userInput: data,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Link Updated Successfully");
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else {
      ErrorToast("Please Add Links");
    }
  };
  return (
    <>
      {openModal ? (
        <Reactportal
          open={openModal}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal}
        >
          <div className="horizontalcontainer ">
            {/* {BookingData && (
              <div className="bookingPageData">
                {Object.keys(BookingData).map((key, index) => {
                  return (
                    <div key={index}>
                      <strong>{key}</strong>: {BookingData[key] ? BookingData[key].toString() : "null"}
                    </div>
                  );
                })}
              </div>
            )} */}
            {/* <pre>{jsonString}</pre> */}
            <OngoingBox data={BookingData} />
            {BookingPageFields.map((e, i) => {
              return (
                <div key={e.id} className="FormSectionParent">
                  {/* <div className="sectionHeadings">{replaceUnderscore(e.name)}</div> */}
                  <div
                    className="FormSection horizontalform bookinginput"
                    style={{ maxWidth: "100%" }}
                  >
                    <BookingPageInputs
                      inputfields={e.fields}
                      Type={e.name}
                      fielddata={BookingData}
                      TypeOfPortal={TypeOfPortal}
                      //   configData={data}
                      //   handleDisabled={handleDisabled}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={submit}
            submitType={"View"}
            SaveAndClose={() => {
              submit();
            }}
            handleformclose={() => {
              Closeformfunction();
              setOpenModal(!openModal);
            }}
          />
        </Reactportal>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default EditBookingPageModal;
